import gql from 'graphql-tag'
export default gql`mutation createConsistencyClassMutation($consistencyClass: BaseConsistencyClass!) {
  createConsistencyClass(consistencyClass: $consistencyClass) {
    code
    description
    minRequirement
    maxRequirement
    minDeviation
    maxDeviation
    maxDeviationsAllowed
    consistencyTestTypes {
      code
      description
      parameters {
        unit
        label
        placeholder
      }
      id
    }
    id
  }
}`